<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/quality_control/query_container/list_quality_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_templates')"
    :params="{
      packing_house_id: packing_house_id,
      packing_house_process_id: packing_house_process_id,
      container_id: container_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      packing_house_process?.name,
      container?.container_code,
      quality_template?.name
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info :container="container"></container-info>

    <div class="mt-6">
      <h1 class="page-title">
        <i class="fa-solid fa-list-ul"></i><span class="space-icon"></span>
        {{ $t("labels.quality_inspects_title") }}
      </h1>

      <div class="mt-8 flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default
            :label="
              quality_inspects.length +
              ' ' +
              $t('labels.total_number_inspections')
            "
          />
        </div>
        <div>
        </div>
      </div>

      <inspection-details
        v-if="quality_template"
        :quality_template="quality_template"
        :quality_inspects="quality_inspects"
        :goToShow="goToShowQualityInspect"
      ></inspection-details>
      <loading-message v-else />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import QueryContainerRequester from "@/views/packing_house/requesters/quality_control/query_container/list_quality_inspects.js";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import ContainerInfo from "@/components/views/packing_house/quality_control/query_container/ContainerInfo.vue";
import InspectionDetails from "@/components/views/packing_house/quality_control/query_container/InspectionDetails.vue";

export default {
  name: "PhQualityControlQueryContainerListQualityInspects",
  components: {
    GoBackLink,
    ContainerInfo,
    InspectionDetails
  },
  data() {
    return {
      load_data_general: false,
      downloading: false,
      packing_house_process: {},
      container: {},
      quality_inspects: [],
      quality_template: {}
    };
  },
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: {
      required: true
    },
    container_id: {
      required: true
    },
    quality_template_id: {
      required: true
    },
    current_tab: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      await this.fetchPackingHouseProcess();
      await this.fetchContainer();
      await this.fetchQualityTemplate();
      await this.fetchQualityInspects();
      this.load_data_general = true;
    },
    inspectsByTemplate: function (current_tab_id) {
      return this.quality_inspects.filter(
        eq_inspect => eq_inspect.quality_template_id === current_tab_id
      );
    },
    maxSamplings: function (arr) {
      return Math.max(...arr.map(eq_inspect => eq_inspect.samplings));
    },
    fetchPackingHouseProcess: async function () {
      let response = await QueryContainerRequester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    downloadRepXlsx: async function () {
      this.downloading = true;
      try {
        let response =
          await QueryContainerRequester.downloadQualityInspectsRepXlsx(
            this.packing_house_id,
            this.container_id,
            this.quality_template.id
          );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let name = this.quality_template?.name;
        if (name) name = `${name.split(" ").join("_")}.xlsx`;
        fileLink.setAttribute("download", name ?? "reporte.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    fetchContainer: async function () {
      let response = await QueryContainerRequester.fetchContainer(
        this.packing_house_id,
        this.packing_house_process_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchQualityInspects: async function () {
      let response = await QueryContainerRequester.fetchQualityInspects(
        this.packing_house_id,
        this.container_id,
        this.quality_template_id
      );
      this.quality_inspects = response.data;
    },
    fetchQualityTemplate: async function () {
      let response = await QueryContainerRequester.fetchQualityTemplate(
        this.packing_house_id,
        this.container_id,
        this.quality_template_id
      );
      this.quality_template = response.data;
    },
    switchTab: function (index) {
      if (this.current_tab) return Number(this.current_tab) === index;
      return index == 0;
    },
    goToShowQualityInspect: function (quality_inspect) {
      this.$router.push({
        name: this.routeName("show_quality_inspect"),
        params: {
          packing_house_id: this.packing_house_id,
          container_id: this.container_id,
          quality_inspect_id: quality_inspect.id,
          packing_house_process_id: this.packing_house_process_id,
          quality_template_id: this.quality_template_id
        }
      });
    }
  }
};
</script>
